import React, { useState } from "react";
import { Link } from "react-router-dom";

const FormModalWrapper = ({
  open,
  onClose,
  breadcrumb,
  title,
  titleContent,
  size = "lg",
  onSave,
  saveDisabled,
  footer,
  children,
}) => {
  const [isExpand, setIsExpand] = useState(false);

  const handleExpand = () => {
    setIsExpand((prev) => !prev);
  };

  const defaultWidth = size === "sm" ? "460px" : "63vw";
  const defaultHeight = size === "sm" ? "auto" : "78vh";

  if (!open) return null;

  return (
    <div
      className="modal fade show"
      tabIndex="-1"
      aria-labelledby="formModalLabel"
      aria-modal="true"
      onClick={onClose}
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1055,
        overflowX: "hidden",
        overflowY: "auto",
        backgroundColor: "#1b252aa1",
        cursor: "default",
      }}
    >
      <div
        className={`modal-dialog ${isExpand ? "custom-expanded" : ""}`}
        onClick={(e) => e.stopPropagation()}
        style={{
          width: isExpand ? "87vw" : defaultWidth,
          height: isExpand ? "90vh" : defaultHeight,
          margin: isExpand ? "30px auto" : "40px auto",
          maxWidth: "none",
          position: "relative",
          cursor: "default",
          transition: "width 0.5s ease, height 0.5s ease",
        }}
      >
        <div className="modal-content" style={{ height: size === "sm" ? "auto" : "100%" }}>
          <div className="modal-header" style={{ padding: "0.75rem 1.25rem" }}>
            <div id="title_sec">
              {breadcrumb && (
                <div className="tagname view">
                  <div className="breadcrumb-container">
                    <Link to="/home" className="breadcrumb-item" title="Home">
                      Home
                    </Link>
                    <span className="hs">/</span>
                    <span className="breadcrumb-item curr">{breadcrumb}</span>
                  </div>
                </div>
              )}
              <div className="modal-title" id="formModalLabel">
                {titleContent ?? (
                  <div className="editable_field">
                    <h1 className="no-border">{title}</h1>
                  </div>
                )}
              </div>
            </div>
            <div className="modal_btn_group">
              <button
                onClick={handleExpand}
                className={isExpand ? "maxBtn" : "minBtn"}
                type="button"
                title={isExpand ? "Shrink" : "Expand"}
              >
                <div style={{ display: isExpand ? "block" : "none" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16.558" height="16.558" viewBox="0 0 16.558 16.558">
                    <path
                      d="M3.763,11.391H8.339m0,0v4.577m0-4.577L3,16.73M15.967,8.339H11.391m0,0V3.763m0,4.577L16.73,3"
                      transform="translate(-1.586 -1.586)"
                      fill="none"
                      stroke="#333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
                <div style={{ display: !isExpand ? "block" : "none" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16.561" height="16.561" viewBox="0 0 16.561 16.561">
                    <path
                      d="M11.392,8.341,16.733,3m0,0H12.155m4.578,0V7.578M8.341,11.392,3,16.733m0,0H7.578M3,16.733V12.155"
                      transform="translate(-1.586 -1.586)"
                      fill="none"
                      stroke="#333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
              </button>
              <button
                type="button"
                className="custom-btn-close"
                aria-label="Close"
                onClick={onClose}
              />
            </div>
          </div>

          <div className="modal-body">{children}</div>

          <div className="modal-footer">
            {footer ?? (
              <>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSave}
                  disabled={saveDisabled}
                >
                  Save
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormModalWrapper;
